// @flow
import * as React from 'react';
import { Redirect } from 'react-router-dom';

import useClientIdFromHostname from 'common/hooks/useClientIdFromHostname';
import useClientId from 'common/hooks/useClientId';

type Props = {
    children: React.Node
};

const ClientIdSync = ({ children }: Props): React.Node => {
    const { clientId: clientIdFromHostname } = useClientIdFromHostname();
    const clientId = useClientId();

    // keep location param clientId in sync with hostname clientId
    if (clientIdFromHostname && clientIdFromHostname !== clientId) {
        return <Redirect to={`/client/${clientIdFromHostname}`} />;
    }

    return children;
};

export default ClientIdSync;
